import React, { Component } from 'react'
import "./index.css"

export default class Header extends Component {
    render() {
        return (
            <div id="headerBlock" lg={12}>
               <h1>Welcome Back to Gekch.io </h1>
            </div>
        ) 
    }
}
